import {
    FW_SET_FLOOR_WARDENS,
    FW_SET_FLOORS,
    FW_TOGGLE_REGISTRATION,
    FW_TOGGLE_DELETE_CONFIRM,
    FW_SET_IS_FLOOR_WARDEN,
    FW_SET_REGISTRATION_TYPE,
    FW_SET_REGISTRATION_ROLE,
    FW_SET_REGISTRATION_POSITION,
    FW_SET_REGISTRATION_FLOOR,
    FW_SET_ERROR_MESSAGE,
    FW_SET_PENDING_REQUEST,
    FW_SET_REGISTRATION_CONFIRMATION,
    FW_ADD_FLOOR_WARDEN_ENTRY,
    FW_REMOVE_FLOOR_WARDEN_ENTRY,
    FW_SET_ACKNOWLEDGED,
    FW_SET_FILTERED_FLOOR_WARDENS,
    FW_SET_FILTERED_REQUESTS,
    FW_SET_FLOOR_WARDEN_REQUESTS,
    FW_REMOVE_FLOOR_WARDEN_REQUEST
} from '../actionTypes'

const defaultState = {
    isLoading: true,
    isFloorWarden: false,
    pendingRequest: false,
    showRegistration: false,
    showDeleteConfirm: false,
    floorWardens: null,
    floorWardenRequests: [],
    filteredArray: null,
    currentRequest: null,
    filteredRequests: null,
    floors: [],
    message: 'Click to register and choose your position.',
    errorMessage: '',
    registrationType: null,
    registrationRoles: null,
    registrationPosition: null,
    registrationFloor: null,
    registrationConfirmation: false,
    confirmationText: '',
    confirmDeleteData: {
        title: 'Confirm Removal',
        content: null,
        onOk: null,
        okText: null,
        okButtonProps: null,
        onCancel: null,
    },
}

const floorWardenReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FW_SET_FLOOR_WARDENS:
            return {
                ...state,
                isLoading: false,
                floorWardens: action.floorWardens,
            }
        case FW_ADD_FLOOR_WARDEN_ENTRY:
            return {
                ...state,
                floorWardens: [...state.floorWardens, action.floorWarden],
            }
        case FW_REMOVE_FLOOR_WARDEN_ENTRY:
            return {
                ...state,
                floorWardens: state.floorWardens.filter((f) => f.email !== action.floorWarden.email),
            }
        case FW_SET_FLOOR_WARDEN_REQUESTS:
            return {
                ...state,
                floorWardenRequests: action.requests,
            }
        case FW_SET_FLOORS:
            return {
                ...state,
                floors: action.floors.sort((a, b) => a - b),
            }
        case FW_SET_IS_FLOOR_WARDEN:
            return {
                ...state,
                isFloorWarden: action.isFloorWarden,
                acknowledged: action.acknowledged,
                version: action.version,
                message: action.message,
                position: action.position,
            }
        case FW_SET_ACKNOWLEDGED:
            return {
                ...state,
                acknowledged: action.acknowledged,
            }
        case FW_TOGGLE_REGISTRATION:
            return {
                ...state,
                showRegistration: !state.showRegistration,
            }
        case FW_TOGGLE_DELETE_CONFIRM:
            return {
                ...state,
                showDeleteConfirm: !state.showDeleteConfirm,
                confirmDeleteData: {
                    ...state.confirmDeleteData,
                    ...action.data,
                },
            }
        case FW_SET_REGISTRATION_FLOOR:
            return {
                ...state,
                registrationFloor: action.floor,
            }
        case FW_SET_REGISTRATION_POSITION:
            return {
                ...state,
                registrationPosition: action.position,
            }
        case FW_SET_REGISTRATION_ROLE:
            return {
                ...state,
                registrationRoles: action.role,
            }
        case FW_SET_REGISTRATION_TYPE:
            return {
                ...state,
                registrationType: action.regType,
            }
        case FW_SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.text,
            }
        case FW_SET_PENDING_REQUEST:
            return {
                ...state,
                pendingRequest: action.value,
                message: action.message,
                currentRequest: action.id,
            }
        case FW_SET_REGISTRATION_CONFIRMATION:
            return {
                ...state,
                registrationConfirmation: action.value,
                confirmationText: action.text,
            }
        case FW_SET_FILTERED_FLOOR_WARDENS: {
            return {
                ...state,
                filteredArray: action.floorWardens,
            }
        }
        case FW_SET_FILTERED_REQUESTS:
            return {
                ...state,
                filteredRequests: action.requests,
            }
        case FW_REMOVE_FLOOR_WARDEN_REQUEST:
            return {
                ...state,
                floorWardenRequests: state.floorWardenRequests.filter((f) => f.pk !== action.request.pk),
            }
        default:
            return state
    }
}

export default floorWardenReducer
